<template>
  <multi-selector v-model="contact" :filterable="false" :options="contactStatusList" :remote="selfStatusSearch"></multi-selector>
</template>
<script>
import MultiSelector from '../Select';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    selfStatus: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      contact: [],
      contactStatusList: []
    };
  },
  mounted() {
    this.selfStatusSearch('');
  },
  watch: {
    contact() {
      this.$emit('input', this.contact.map(item => item.modelCode));
    }
  },
  methods: {
    // 本人状态下拉框
    selfStatusSearch(val) {
      this.$ajax({
        method: 'GET',
        url: '/dict/getList/zhixidianhuaContactStatus',
        params: { 'val': val }
      }).then((res) => {
        res.data.map((item) => { item.title = item.modelName; return item; });
        this.contactStatusList = res.data;
        this.contactStatusList.forEach((item) => {
          if (this.selfStatus.indexOf(item.modelCode) !== -1) {
            this.contact.push(item);
          }
        });
      });
    }
  },
  components: {
    MultiSelector
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness-select/ContactStatusSelector.vue